module.exports = __webpack_public_path__ + "img/icon-5.2236d2cd.png";